<header id="lm-header">
    <div *ngIf="resources && shouldShowQuestion()">
        Which one do you like more?
        <span (click)="voteResource(0)" class="vote-resource"
            >"{{ resources[0].title.title }}"</span
        >
        or
        <span (click)="voteResource(1)" class="vote-resource">"{{ resources[1].title.title }}"</span
        >?
    </div>
</header>

<section class="student-search-container">
    <div *ngIf="!subjectTree; else elseBlock">
        <app-preloader></app-preloader>
    </div>

    <ng-template #elseBlock>
        <div
            class="container w-100 ds-vertical-menu-container"
            [ngStyle]="{ 'background-image': heroImageUrl }"
        >
            <div class="row-auto g-0">
                <div
                    @fadeAnimation
                    class="col-xs-12 col-lg-6 col-xl justify-content-lg-end justify-content-xs-center text-xs-center text-lg-left vertical-menu-text pt-4 pt-lg-0"
                >
                    <h1 class="text-start">
                        What will you explore <br />
                        today?
                    </h1>
                </div>

                <div @fadeAnimation class="col-xs-12 col-lg-6 col-xl">
                    <app-vertical-menu
                        (selectedSubject)="onSelectedSubject($event)"
                        [showNavigation]="isDesktopResolution"
                        [subjectTree]="subjectTree"
                        [swiperOptions]="swiperOptions"
                    ></app-vertical-menu>
                </div>

                <div
                    *ngIf="subjectTreeChildren.length && isDesktopResolution"
                    @slideInOut
                    class="col-xl"
                >
                    <app-student-subjects-grid
                        [subjectTreeChildren]="subjectTreeChildren"
                    ></app-student-subjects-grid>

                    <div class="row-auto justify-content-center">
                        <app-link [appRouterLink]="['/subjects' + slug]">
                            <a
                                *ngIf="remainingChildrenNr"
                                class="btn btn-primary gtm-student-cloud-explore-more"
                                >and {{ remainingChildrenNr }} more...</a
                            >
                            <a
                                *ngIf="!remainingChildrenNr"
                                class="btn btn-primary gtm-student-cloud-explore-all"
                                >Explore all</a
                            >
                        </app-link>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</section>
<section class="container second-enter-code-wrapper">
    <div class="row-auto pt-lg-6">
        <div class="col-12 col-lg-6 info pe-lg-5">
            <h6 class="mt-6 mt-lg-7 fw-bold">Have a code from your teacher? Enter it here:</h6>
        </div>
        <div class="col-12 col-lg-6 ps-lg-5">
            <form
                class="mt-3 mb-6 second-enter-code selenium-second-enter-code gtm-second-enter-code-go"
            >
                <input
                    [(ngModel)]="code"
                    aria-label="Enter code from your teacher"
                    class="form-control"
                    name="code"
                    ngModel
                    placeholder="Enter code from your teacher"
                    type="search"
                />
                <button
                    (click)="enterCode($event)"
                    class="btn btn-primary enter-code-go"
                    type="submit"
                >
                    Go
                </button>
            </form>
        </div>
    </div>
</section>
